import { render } from "./slideout-cart-item.vue?vue&type=template&id=72874685"
import script from "./slideout-cart-item.vue?vue&type=script&lang=js"
export * from "./slideout-cart-item.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__